// StorePageFour.tsx
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { updateForm } from "../../../redux/storeFormSlice";
import { useNavigate, useParams } from "react-router-dom";
import SubmitButton from "../../../components/form/SubmitButton";
import MainTitle from "../../../components/ui/MainTitle";
import BackButton from "../../../components/ui/BackButton";
import { useTranslation } from "react-i18next";
import FileUpload from "../../../components/form/FileUpload";

export default function StorePageFour() {
  const { ownerId} = useParams<{ ownerId: string}>();
   const numericOwnerId = ownerId ? parseInt(ownerId) : 0;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { logo, coverImage } = useSelector((state: RootState) => state.storeForm);

  const [logoFile, setLogoFile] = useState<File | null>(logo);
  const [coverFile, setCoverFile] = useState<File | null>(coverImage);

  const onNext = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    dispatch(updateForm({ logo: logoFile, coverImage: coverFile }));
    navigate(numericOwnerId?`/admin/owners/${numericOwnerId}/add-store/page5` :"/owner/add-store/page5");
  };

  return (
    <div className="container p-6 h-[100vh] overflow-auto">
      <MainTitle title={t("public_information")} />

      <form
        className="flex flex-col gap-8 w-full max-w-lg mx-auto mt-16"
        onSubmit={onNext}
      >
        <FileUpload
          file={logoFile}
          setFile={setLogoFile}
          label={t("store_logo")}
          addText={t("add_logo")}
          shape="circle"
          size={128}
        />

        <FileUpload
          file={coverFile}
          setFile={setCoverFile}
          label={t("store_cover")}
          addText={t("add_cover")}
          shape="rectangle"
          size={192}
        />

        <div className="grid grid-cols-2 gap-4">
          <BackButton url={numericOwnerId?`/admin/owners/${numericOwnerId}/add-store/page3` :"/owner/add-store/page3"} height={64} />
          <SubmitButton height={64} label={"next"} />
        </div>
      </form>
    </div>
  );
}
